// Annoyingly, the enum values are not actually exported from the client types
// like how __typenames are. So we have to manually define them here.
// https://hubspot.slack.com/archives/C052KTDQMT6/p1749506458082019
const ROOT = 'GRID';
export const SECTION = 'SECTION';
export const CONTAINER = 'CONTAINER';
export const MODULE = 'MODULE';
export const EDITOR_PROVIDED_MODULE_STYLES = 'EDITOR_PROVIDED_MODULE_STYLES';
export const STYLE_FIELDS_MODULE_STYLES = 'STYLE_FIELDS_MODULE_STYLES';
export const OLD_MODULE_STYLES = 'OLD_MODULE_STYLES';
export const GRID_NODE_TYPES = {
  ROOT,
  SECTION,
  CONTAINER,
  MODULE
};
export const GRID_NODE_TYPE_TO_DOM_UNIQUE_ID = {
  [GRID_NODE_TYPES.SECTION]: 'section',
  [GRID_NODE_TYPES.CONTAINER]: 'container',
  [GRID_NODE_TYPES.MODULE]: 'module'
};
const STACK = 'STACK';
const GRID = 'GRID';
const PEGBOARD = 'PEGBOARD';
export const CONTAINER_TYPES = {
  STACK,
  GRID,
  PEGBOARD
};
const ROW = 'ROW';
const COLUMN = 'COLUMN';
export const AUTO_FLOW_TYPES = {
  ROW,
  COLUMN
};
const VERTICAL = 'VERTICAL';
const HORIZONTAL = 'HORIZONTAL';
export const STACK_DIRECTIONS = {
  VERTICAL,
  HORIZONTAL
};
const ALIGN_ITEMS_START = 'START';
const ALIGN_ITEMS_CENTER = 'CENTER';
const ALIGN_ITEMS_END = 'END';
const ALIGN_ITEMS_STRETCH = 'STRETCH';
export const ALIGN_ITEMS = {
  START: ALIGN_ITEMS_START,
  CENTER: ALIGN_ITEMS_CENTER,
  END: ALIGN_ITEMS_END,
  STRETCH: ALIGN_ITEMS_STRETCH
};
const JUSTIFY_CONTENT_START = 'START';
const JUSTIFY_CONTENT_CENTER = 'CENTER';
const JUSTIFY_CONTENT_END = 'END';
const JUSTIFY_CONTENT_SPACE_BETWEEN = 'SPACE_BETWEEN';
const JUSTIFY_CONTENT_SPACE_AROUND = 'SPACE_AROUND';
const JUSTIFY_CONTENT_SPACE_EVENLY = 'SPACE_EVENLY';
export const JUSTIFY_CONTENT = {
  START: JUSTIFY_CONTENT_START,
  CENTER: JUSTIFY_CONTENT_CENTER,
  END: JUSTIFY_CONTENT_END,
  SPACE_BETWEEN: JUSTIFY_CONTENT_SPACE_BETWEEN,
  SPACE_AROUND: JUSTIFY_CONTENT_SPACE_AROUND,
  SPACE_EVENLY: JUSTIFY_CONTENT_SPACE_EVENLY
};
const GAP_UNIFIED = 'UNIFIED';
const GAP_SPLIT = 'SPLIT';
export const GAP_TYPES = {
  UNIFIED: GAP_UNIFIED,
  SPLIT: GAP_SPLIT
};
const CM = 'CM';
const MM = 'MM';
const Q = 'Q';
const IN = 'IN';
const PC = 'PC';
const PT = 'PT';
const PX = 'PX';
const EM = 'EM';
const EX = 'EX';
const CH = 'CH';
const REM = 'REM';
const LH = 'LH';
const VW = 'VW';
const VH = 'VH';
const VMIN = 'VMIN';
const VMAX = 'VMAX';
const PERCENTAGE = 'PERCENTAGE';
const FRACTION = 'FRACTION';
export const UNITS = {
  CM,
  MM,
  Q,
  IN,
  PC,
  PT,
  PX,
  EM,
  EX,
  CH,
  REM,
  LH,
  VW,
  VH,
  VMIN,
  VMAX,
  PERCENTAGE,
  FRACTION
};
const CONTENT_WIDTH_FULL = 'FULL_WIDTH';
const CONTENT_WIDTH_MAX = 'MAX_WIDTH';
export const CONTENT_WIDTH_TYPES = {
  FULL_WIDTH: CONTENT_WIDTH_FULL,
  MAX_WIDTH: CONTENT_WIDTH_MAX
};
const POSITION_AUTO = 'AUTO';
const POSITION_MANUAL = 'MANUAL';
export const POSITION_TYPES = {
  AUTO: POSITION_AUTO,
  MANUAL: POSITION_MANUAL
};
const ROW_COLUMN_SIZE_AUTO = 'AUTO';
const ROW_COLUMN_SIZE_MAX_CONTENT = 'MAX_CONTENT';
const ROW_COLUMN_SIZE_MIN_CONTENT = 'MIN_CONTENT';
const ROW_COLUMN_SIZE_SIZED = 'SIZED';
const ROW_COLUMN_SIZE_MINMAX = 'MINMAX';
export const ROW_COLUMN_SIZE_TYPES = {
  AUTO: ROW_COLUMN_SIZE_AUTO,
  MAX_CONTENT: ROW_COLUMN_SIZE_MAX_CONTENT,
  MIN_CONTENT: ROW_COLUMN_SIZE_MIN_CONTENT,
  SIZED: ROW_COLUMN_SIZE_SIZED,
  MINMAX: ROW_COLUMN_SIZE_MINMAX
};
const WIDTH_SIZED = 'SIZED';
const WIDTH_FIT_CONTENT = 'FIT_CONTENT';
export const WIDTH_TYPES = {
  SIZED: WIDTH_SIZED,
  FIT_CONTENT: WIDTH_FIT_CONTENT
};
const BACKGROUND_IMAGE_SIZE_CONTAIN = 'CONTAIN';
const BACKGROUND_IMAGE_SIZE_COVER = 'COVER';
const BACKGROUND_IMAGE_SIZE_AUTO = 'AUTO';
export const BACKGROUND_IMAGE_SIZES = {
  CONTAIN: BACKGROUND_IMAGE_SIZE_CONTAIN,
  COVER: BACKGROUND_IMAGE_SIZE_COVER,
  AUTO: BACKGROUND_IMAGE_SIZE_AUTO
};
const BACKGROUND_IMAGE_POSITION_TOP_LEFT = 'TOP_LEFT';
const BACKGROUND_IMAGE_POSITION_TOP_CENTER = 'TOP_CENTER';
const BACKGROUND_IMAGE_POSITION_TOP_RIGHT = 'TOP_RIGHT';
const BACKGROUND_IMAGE_POSITION_MIDDLE_LEFT = 'MIDDLE_LEFT';
const BACKGROUND_IMAGE_POSITION_MIDDLE_CENTER = 'MIDDLE_CENTER';
const BACKGROUND_IMAGE_POSITION_MIDDLE_RIGHT = 'MIDDLE_RIGHT';
const BACKGROUND_IMAGE_POSITION_BOTTOM_LEFT = 'BOTTOM_LEFT';
const BACKGROUND_IMAGE_POSITION_BOTTOM_CENTER = 'BOTTOM_CENTER';
const BACKGROUND_IMAGE_POSITION_BOTTOM_RIGHT = 'BOTTOM_RIGHT';
export const BACKGROUND_IMAGE_POSITIONS = {
  TOP_LEFT: BACKGROUND_IMAGE_POSITION_TOP_LEFT,
  TOP_CENTER: BACKGROUND_IMAGE_POSITION_TOP_CENTER,
  TOP_RIGHT: BACKGROUND_IMAGE_POSITION_TOP_RIGHT,
  MIDDLE_LEFT: BACKGROUND_IMAGE_POSITION_MIDDLE_LEFT,
  MIDDLE_CENTER: BACKGROUND_IMAGE_POSITION_MIDDLE_CENTER,
  MIDDLE_RIGHT: BACKGROUND_IMAGE_POSITION_MIDDLE_RIGHT,
  BOTTOM_LEFT: BACKGROUND_IMAGE_POSITION_BOTTOM_LEFT,
  BOTTOM_CENTER: BACKGROUND_IMAGE_POSITION_BOTTOM_CENTER,
  BOTTOM_RIGHT: BACKGROUND_IMAGE_POSITION_BOTTOM_RIGHT
};
const BACKGROUND_LAYER_COLOR = 'COLOR';
const BACKGROUND_LAYER_GRADIENT = 'GRADIENT';
const BACKGROUND_LAYER_IMAGE = 'IMAGE';
export const BACKGROUND_LAYER_TYPES = {
  COLOR: BACKGROUND_LAYER_COLOR,
  GRADIENT: BACKGROUND_LAYER_GRADIENT,
  IMAGE: BACKGROUND_LAYER_IMAGE
};
const HORIZONTAL_SIDE_LEFT = 'LEFT';
const HORIZONTAL_SIDE_RIGHT = 'RIGHT';
export const HORIZONTAL_SIDES = {
  LEFT: HORIZONTAL_SIDE_LEFT,
  RIGHT: HORIZONTAL_SIDE_RIGHT
};
const VERTICAL_SIDE_TOP = 'TOP';
const VERTICAL_SIDE_BOTTOM = 'BOTTOM';
export const VERTICAL_SIDES = {
  TOP: VERTICAL_SIDE_TOP,
  BOTTOM: VERTICAL_SIDE_BOTTOM
};
const ERROR_TYPE_MISSING_PORTAL_ID = 'MISSING_PORTAL_ID';
const ERROR_TYPE_MISSING_USER_ID = 'MISSING_USER_ID';
export const ERROR_TYPES = {
  MISSING_PORTAL_ID: ERROR_TYPE_MISSING_PORTAL_ID,
  MISSING_USER_ID: ERROR_TYPE_MISSING_USER_ID
};
export const BUILDING_BLOCK_TYPES = {
  HORIZONTAL_STACK: 'HORIZONTAL_STACK',
  VERTICAL_STACK: 'VERTICAL_STACK',
  TABLE: 'TABLE'
};
export const BUILDING_BLOCKS = {
  HORIZONTAL_STACK: {
    type: BUILDING_BLOCK_TYPES.HORIZONTAL_STACK,
    label: 'Row',
    icon: 'row'
  },
  VERTICAL_STACK: {
    type: BUILDING_BLOCK_TYPES.VERTICAL_STACK,
    label: 'Column',
    icon: 'column'
  },
  TABLE: {
    type: BUILDING_BLOCK_TYPES.TABLE,
    label: 'Table',
    icon: 'grid'
  }
};
export const SIDEBAR_PANELS = {
  addWidget: 'add',
  edit: 'edit'
};